var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignmentLeft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.05C3 3.88431 3.13431 3.75 3.3 3.75H14.7C14.8657 3.75 15 3.88431 15 4.05V6.45C15 6.61569 14.8657 6.75 14.7 6.75H3.3C3.13432 6.75 3 6.61569 3 6.45V4.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.55C3 8.38431 3.13431 8.25 3.3 8.25H19.2C19.3657 8.25 19.5 8.38431 19.5 8.55V10.95C19.5 11.1157 19.3657 11.25 19.2 11.25H3.3C3.13431 11.25 3 11.1157 3 10.95V8.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.05C3 12.8843 3.13431 12.75 3.3 12.75H17.7C17.8657 12.75 18 12.8843 18 13.05V15.45C18 15.6157 17.8657 15.75 17.7 15.75H3.3C3.13432 15.75 3 15.6157 3 15.45V13.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.55C3 17.3843 3.13431 17.25 3.3 17.25H20.7C20.8657 17.25 21 17.3843 21 17.55V19.95C21 20.1157 20.8657 20.25 20.7 20.25H3.3C3.13431 20.25 3 20.1157 3 19.95V17.55Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignmentLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alignment-left.58e6775c008d4ae1fb1287b327dfeb51.svg";